import React from "react";
import { Box } from "@mui/material";

import clearIcon from "../assets/clear-icon.png";
import deleteIcon from "../assets/delete-icon.png";
import editIcon from "../assets/edit-icon.png";
import dropArrowIcon from "../assets/drop-arrow.png";
import upArrowIcon from "../assets/up-arrow.png";
import downloadIcon from "../assets/download.png";

type IconButtonProps = Omit<
  React.ComponentProps<typeof Box>,
  "component" | "src"
> & {
  src: string;
};

const IconButton: React.FC<IconButtonProps> = ({ src, ...props }) => (
  <Box
    component="img"
    src={src}
    width={20}
    height={20}
    sx={{ cursor: "pointer" }}
    {...props}
  />
);

// Usage
export const CloseButton = (props: Omit<IconButtonProps, "src">) => (
  <IconButton src={clearIcon} {...props} />
);
export const EditButton = (props: Omit<IconButtonProps, "src">) => (
  <IconButton src={editIcon} {...props} />
);
export const DeleteButton = (props: Omit<IconButtonProps, "src">) => (
  <IconButton src={deleteIcon} {...props} />
);
export const UpIconButton = (props: Omit<IconButtonProps, "src">) => (
  <IconButton src={upArrowIcon} {...props} />
);
export const DropIconButton = (props: Omit<IconButtonProps, "src">) => (
  <IconButton src={dropArrowIcon} {...props} />
);

//
export const DownloadIconButton = (props: Omit<IconButtonProps, "src">) => (
  <IconButton src={downloadIcon} {...props} />
);
